import React, { ReactNode } from "react";
import { Location, useLocation, useNavigate } from "react-router-dom";
// import * as Sentry from "@sentry/react";

type ErrorBoundaryProps = {
    children: ReactNode;
    location: Location;
    navigate: any; // TODO
};
type ErrorBoundaryState = {
    hasError: boolean;
    error: object | null;
};

class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error: error.message };
    }

    componentDidCatch(error, errorInfo) {
        if (this.props.location.pathname !== "/error-page") {
            this.setState({ hasError: false });
            this.props.navigate("/error-page");
        }
    }

    render() {
        if (this.state.hasError) return <h1>System core error!</h1>;

        return this.props.children;
    }
}

const withNavigation = (Component) => {
    const DecoratedErrorBoundary = (props) => {
        const navigate = useNavigate();
        const location = useLocation();

        return <Component {...props} navigate={navigate} location={location} />;
    };
    return DecoratedErrorBoundary;
};

export default withNavigation(ErrorBoundary);
